import { useAuth } from "@/contexts/AuthContext";
import { useMemo } from "react";

import { type APIInstance, createAPI } from "../services/apiService";

/**
 * Hook to use the authenticated API instance.
 *
 * The returned instance is stable across auth status transitions (login, logout,
 * expiry) — it reads the current session live at request time rather than closing
 * over a snapshot — so consumers that depend on it (e.g. effects fetching on mount)
 * don't get spuriously re-triggered by auth state changes.
 * @param version API version ("v1" or "v2")
 * @returns Axios instance with auth interceptors
 */
export const useAPI = (version: "v1" | "v2" = "v1"): APIInstance => {
  const { getAccessToken } = useAuth();
  return useMemo(() => createAPI(getAccessToken, version), [getAccessToken, version]);
};
